import React, { useEffect, } from 'react';
import { connect, } from 'react-redux';
import { useHistory, } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

import { DEFAULT_PAPER_ELEVATION, } from 'common/constants';
import { routes, } from '../../common/routes';
import Icon from 'common/components/Icon';
import { StoreBasicDataApiStructure, } from 'common/types';
import { repositories, } from 'api';

type Props = {
    order: StoreBasicDataApiStructure<repositories.order.OrderType>,
};

const Confirm: React.FC<Props> = ({ order, }) => {
    const history = useHistory();

    useEffect(
        () => {
            const state = history.location.state;

            if (state?.referrer !== routes.SUMMARY || !state?.termsAcceptance) {
                history.goBack();
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    useEffect(() => () => {
       if (history.action === 'POP' && history.location.pathname.includes('/checkout')) {
           window.location.replace('/products');
           return;
       }
    },[ history.action, history.location.pathname, ]);

    return (
        <Paper elevation={DEFAULT_PAPER_ELEVATION}
               square
               style={{ margin: '2rem 0' }}>
            <Box px={{ xs: 2, md: 0, }}
                 py={2}>
                <Grid container
                      justify="center"
                      direction="column"
                      alignItems="center">
                    <Grid item>
                        <Box my={1}>
                            <Icon.CartConfirmation />
                        </Box>
                    </Grid>
                    <Grid item>
                        <Typography variant="h5"
                                    paragraph>
                            Zamówienie nr {order.data.orderNumber} zostało przyjęte do realizacji.
                        </Typography>
                        <Box my={4}>
                            <Typography variant="body1">
                                Informacje ze szczególami zamówienia zostały wysłane na Twój adres e-mail.
                            </Typography>
                            <Typography variant="body1"
                                        paragraph>
                                Możesz je również pobrać w postaci pliku <Link href={order.data.pdf}>PDF</Link>.
                            </Typography>
                        </Box>
                        <Typography variant="body1"
                                    paragraph>
                            Dziękujemy za zakupy!
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};

type MappingType = {
    order: StoreBasicDataApiStructure<repositories.order.OrderType>,
};

const mapStateToProps = ({ order, }: MappingType) => ({ order, });

export default connect(
    mapStateToProps,
)(Confirm);